import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toNumber, getItemFromArray, getPointForRef } from "../../components/Common";
import * as APP from "../../redux_store/appState";
import { ClearScratch } from "../layout/PaperDesigner";
import { updateLayout2D } from "../../redux_store/appStateHelper";
import { updateAreaSpecification, updateJobParameter } from "../../redux_store/jobState";
import { common } from "@material-ui/core/colors";
import { set } from "lodash";
import SpecModifyBeamPostsMenuItem from "./SpecModifyBeamPostsMenuItem";
import Message from "../../components/Message";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

export const GetItems = (parameters) => {
    if (window.svg && window.paper) {
        return window.paper.project.getItems(parameters);
    }
    return null;
};

const SetChildrenGrey = (item, ChangePost) => {
    if (!item?.children) return;
    item.children.forEach(function (item) {
        if (window.last_pop_item === item) {
            return;
        }
        if (item.is_splice_post) {
            if (item.strokeColor) item.strokeColor = "#000000";
            item.fillColor = "#bbb";
            return;
        }
        if (item?.beam_ref?.includes && item.beam_ref.includes("Portal")) {
            if (item.strokeColor) item.strokeColor = "#000000";
            item.fillColor = "#bbb";
            return;
        }
        if (item.is_post) {
            return;
        }
        if (item.is_splice) {
            return;
        }
        let alpha = item.fillColor?.alpha;
        if (item.fillColor) {
            item.fillColor = "#dddddd";
            if (alpha) item.fillColor.alpha = alpha;
        }
        if (item.strokeColor) item.strokeColor = "#bbbbbb";
        if (item.is_beam) {
            item.fillColor = "#bbb";
            item.onMouseEnter = function (event) {
                item.fillColor = "#448826ff";
                item.cursor = "pointer";
                window.paper.view.element.style.cursor = "pointer";
            };
            item.onMouseLeave = function (event) {
                if (item != window.last_pop_item) {
                    item.fillColor = "#bbb";
                }
                window.paper.view.element.style.cursor = "move";
            };
            item.onClick = function (event) {
                window.dragging = false;
                item.fillColor = "#332197";
                ChangePost(item);
            };
        }
        item.pickable = false;
        if (item.children) {
            SetChildrenGrey(item, ChangePost);
        }
    });
};

function projectPointToLine(mousePoint, p1, p2, online) {
    const v = p2.subtract(p1); // Direction vector of the line
    const w = mousePoint.subtract(p1);
    let t = w.dot(v) / v.dot(v); // Projection scalar
    if (online) {
        t = Math.max(0, Math.min(1, t)); // Clamp t to [0, 1]
    }
    return p1.add(v.multiply(t));
}

function distancePointToLine(point, lineStart, lineEnd, absolute = true) {
    const v = lineEnd.subtract(lineStart); // Direction vector of the line
    const w = point.subtract(lineStart); // Vector from lineStart to point

    // 2D cross product
    const cross = v.x * w.y - v.y * w.x;
    const distance = absolute ? Math.abs(cross) / v.length : cross / v.length;
    return distance;
}

function offsetPointOnNormal(point, lineStart, lineEnd, distance) {
    // Step 1: Direction vector of the line
    const v = lineEnd.subtract(lineStart);
    // Step 2: Normal vector (perpendicular)
    const normal = new window.paper.Point(-v.y, v.x);
    // Step 3: Normalize
    const normalUnit = normal.normalize();
    // Step 4: Scale by distance
    const offset = normalUnit.multiply(distance);
    // Step 5: Offset the point
    return point.add(offset);
}

function offsetPointAlongLine(point, lineStart, lineEnd, distance) {
    // Direction vector from lineStart to lineEnd
    const direction = lineEnd.subtract(lineStart).normalize();
    // Offset the point along the direction by 'distance'
    return point.add(direction.multiply(distance));
}
export function distanceBetween(p1, p2) {
    if (!p1 || !p2) return 0;
    // Preferred: built-in method if available
    if (typeof p1.distance === "function") return p1.distance(p2);
    // Fallback: vector difference length
    return p1.subtract(p2).length;
}

export default function SpecMovePost(props) {
    const dispatch = useDispatch();
    const app = useSelector((state) => state.app);

    const SELECT_POINT = app.designer.designer2D[APP.SELECT_POINT];
    const [loaded, setLoaded] = React.useState(false);
    const [firstItem, setFirstItem] = React.useState(false);
    const [showSpliceMessage, setShowSpliceMessage] = React.useState(false);
    const [showPortalPostMessage, setShowPortalPostMessage] = React.useState(false);

    const [lastSVGLoaded, setLastSVGLoaded] = React.useState(window.last_svg_load_attempt);
    const AreaSpecifications = useSelector((state) => state.job.AreaSpecifications);
    const areaIndex = props?.pop_item ? props?.pop_item.areaIndex : 0;

    const [selectedItem, setSelectedItem] = React.useState(props.pop_item);

    let AreaSpecifications_PostPositionAdjustments = {};

    for (let index in AreaSpecifications) {
        let this_areaIndex = Number(index);
        if (AreaSpecifications[this_areaIndex]?.PostPositionAdjustments) {
            AreaSpecifications_PostPositionAdjustments[this_areaIndex] = {
                ...AreaSpecifications[this_areaIndex].PostPositionAdjustments,
            };
        }
    }

    const [postAdjustmentsOriginal, setPostAdjustmentsOriginal] = React.useState(
        AreaSpecifications_PostPositionAdjustments
    );

    const [postAdjustments, setPostAdjustments] = React.useState(AreaSpecifications_PostPositionAdjustments);

    const postAdjustmentsRef = React.useRef(postAdjustments); // needed for reference to state inside paper.js

    React.useEffect(() => {
        postAdjustmentsRef.current = postAdjustments;
    }, [postAdjustments]);

    // React.useEffect(() => {
    //     if (JSON.stringify(AreaSpecifications_PostPositionAdjustments) !== JSON.stringify(postAdjustments)) {
    //         setPostAdjustmentsOriginal(AreaSpecifications_PostPositionAdjustments);
    //         setPostAdjustments(AreaSpecifications_PostPositionAdjustments);
    //     }
    // }, [AreaSpecifications_PostPositionAdjustments]);

    React.useEffect(() => {
        if (!loaded) return;
        if (SELECT_POINT === false) {
            // Right button - cancel
            window.move_post_waiting_for_points = false;
            let distance = distanceBetween(window.last_pop_item.position, window.last_pop_item.beam_start_pnt);
            UpdatePostAdjustment(distance, true);
            // group.position = group.initial_position;
            onClose();
        }
    }, [SELECT_POINT]);

    if (loaded && window.move_post_waiting_for_points && window.last_svg_load_attempt != lastSVGLoaded) {
        setLastSVGLoaded(window.last_svg_load_attempt);
        reFormatSVG(0);
    }

    // --- caret blink helpers (insert here) ---
    function startCaretBlink() {
        stopCaretBlink();
        window._caretVisible = false;
        window._caretInterval = setInterval(() => {
            if (!window.paperTextTyping) {
                stopCaretBlink();
                return;
            }
            try {
                const txt = window.paperTextTyping;
                // normalize any existing caret to underscore
                let base = txt.content.replace(/\|/g, "_");
                const idx = base.indexOf("_");
                if (idx < 0) {
                    // nothing to blink, stop
                    stopCaretBlink();
                    return;
                }
                // toggle caret char at first underscore
                window._caretVisible = !window._caretVisible;
                const char = window._caretVisible ? "|" : "_";
                base = base.substring(0, idx) + char + base.substring(idx + 1);
                txt.content = base;
            } catch (e) {
                stopCaretBlink();
            }
        }, 500); // blink interval ms
    }

    function stopCaretBlink() {
        try {
            if (window._caretInterval) {
                clearInterval(window._caretInterval);
            }
        } catch (e) {}
        window._caretInterval = null;
        window._caretVisible = false;
        // ensure any leftover '|' becomes '_'
        if (window.paperTextTyping && typeof window.paperTextTyping.content === "string") {
            window.paperTextTyping.content = window.paperTextTyping.content.replace(/\|/g, "_");
        }
    }

    function reFormatSVG(count) {
        if (!window.move_post_waiting_for_points) return;
        if (count > 30) {
            if (window.move_post_waiting_for_points) {
                FormatSVG(
                    window?.last_pop_item?.is_post || window?.last_pop_item?.is_beam
                        ? window.last_pop_item
                        : props.pop_item
                );
            }
            return;
        }
        setTimeout(function () {
            if (window.move_post_waiting_for_points) {
                if (firstItem == window.window.paper.project.activeLayer.children[0]) {
                    reFormatSVG(count + 1);
                } else {
                    FormatSVG(
                        window?.last_pop_item?.is_post || window?.last_pop_item?.is_beam
                            ? window.last_pop_item
                            : props.pop_item
                    );
                }
            }
        }, 200);
    }

    function ChangePost(new_post) {
        if (window.last_pop_item) {
            let distance = distanceBetween(window.last_pop_item.position, window.last_pop_item.beam_start_pnt);
            UpdatePostAdjustment(distance, false);
        }

        if (new_post.is_beam) {
            window.last_pop_item = new_post;
            setSelectedItem(new_post);

            //clear temp lines
            let temp_lines = GetItems({ temp: true });
            temp_lines.forEach(function (line) {
                line.remove();
            });

            let items = GetItems();
            if (items?.[0]?.children) {
                SetChildrenGrey(items?.[0], ChangePost);
            }

            const post_group = new window.paper.Group();
            post_group.beam_p1 = new_post.parent_p1;
            post_group.beam_p2 = new_post.parent_p2;

            UpdateBeamStartAndEndMarks(post_group);

            return;
        }

        if (!new_post?.post_adjustment_ref && new_post?.nameQQ) {
            let post_items = GetItems({ nameQQ: new_post.nameQQ });
            // setup post_lines to planes
            post_items.forEach(function (post) {
                if (post.is_post && post.post_adjustment_ref) {
                    new_post = post;
                    return;
                }
            });
        }

        if (!new_post?.post_adjustment_ref) {
            return;
        }
        // UpdatePostAdjustment(distance);
        window.last_pop_item = new_post;
        FormatSVG(new_post);
        // dispatch(updateLayout2D());
    }

    function updateDimensions(point) {
        const beam_start_pnt = window.last_pop_item.beam_start_pnt;
        const beam_end_pnt = window.last_pop_item.beam_end_pnt;
        const start_range_pnt = window.last_pop_item.start_range_pnt;
        const end_range_pnt = window.last_pop_item.end_range_pnt;
        const offset_dist = window.last_pop_item.offset_dist;
        const dim_offset = 150;

        const point_on_line = projectPointToLine(point, start_range_pnt, end_range_pnt, true);
        const projected = offsetPointOnNormal(point_on_line, start_range_pnt, end_range_pnt, offset_dist);
        window.last_pop_item.position = projected;

        var projected_dim_start = offsetPointOnNormal(point_on_line, start_range_pnt, end_range_pnt, dim_offset);
        var projected_dim_end = offsetPointOnNormal(beam_start_pnt, start_range_pnt, end_range_pnt, dim_offset);
        drawDimensionLine(projected_dim_start, projected_dim_end);

        projected_dim_end = projected_dim_start;
        projected_dim_start = offsetPointOnNormal(beam_end_pnt, start_range_pnt, end_range_pnt, dim_offset);
        drawDimensionLine(projected_dim_start, projected_dim_end, true);
    }

    function UpdateOriginalPostAdjustment(areaIndex, new_adjustment) {
        let new_postAdjustments = { ...postAdjustmentsRef.current };
        new_postAdjustments[areaIndex] = new_adjustment;
        setPostAdjustmentsOriginal({ ...new_postAdjustments });
        setPostAdjustments({ ...new_postAdjustments });
    }

    function FormatSVG(pop_item) {
        if (!window.move_post_waiting_for_points) {
            return;
        }

        let post_items = GetItems({ is_post: true });

        let post_adjustment_ref = pop_item.post_adjustment_ref;
        if (!post_adjustment_ref) {
            post_adjustment_ref = pop_item?.post_data?.post_adjustment_ref;
        }

        if (pop_item.is_beam || !post_adjustment_ref) {
            let items = GetItems();
            if (items?.[0]?.children) {
                SetChildrenGrey(items?.[0], ChangePost);
            }
            // setup post_lines to planes
            post_items.forEach(function (post) {
                if (post.is_splice_post || (post.beam_ref && post.beam_ref.includes("Portal"))) {
                    post.onMouseDown = function (event) {
                        window.dragging = false;
                        if (post.is_splice_post) {
                            setShowSpliceMessage(true);
                        } else {
                            setShowPortalPostMessage(true);
                        }
                    };
                } else {
                    post.onMouseDown = function (event) {
                        window.dragging = false;
                        ChangePost(post);
                    };
                }
            });
            return;
        }

        pop_item.selected = false;
        if (!pop_item) {
            pop_item = window.last_pop_item;
        } else {
            window.last_pop_item = pop_item;
        }
        let group = pop_item;

        // in case of reload ensure pop_item is from the curent collection svg

        let post_item_found_in_current_svg_collection = false;
        for (const post of post_items) {
            if (
                post.areaIndex == pop_item.areaIndex &&
                post.post_adjustment_ref == post_adjustment_ref &&
                post.left_offset_max &&
                post.right_offset_max &&
                post.beam_p1 &&
                post.post_ref &&
                !post.is_temp_group
            ) {
                window.last_pop_item = post;
                pop_item = post;
                group = post;
                post_item_found_in_current_svg_collection = true;
                break;
            }
        }
        if (!post_item_found_in_current_svg_collection) {
            let items = GetItems();
            if (items?.[0]?.children) {
                SetChildrenGrey(items?.[0], ChangePost);
            }
            UpdateBeamStartAndEndMarks(group);
            // setup post_lines to planes
            post_items.forEach(function (post) {
                post.bringToFront();
                if (post.is_splice_post || (post.beam_ref && post.beam_ref.includes("Portal"))) {
                    post.onMouseDown = function (event) {
                        window.dragging = false;
                        if (post.is_splice_post) {
                            setShowSpliceMessage(true);
                        } else {
                            setShowPortalPostMessage(true);
                        }
                    };
                } else {
                    post.onMouseDown = function (event) {
                        window.dragging = false;
                        ChangePost(post);
                    };
                }
            });

            return;
        }

        //clear temp lines
        let temp_lines = GetItems({ temp: true });
        temp_lines.forEach(function (line) {
            line.remove();
        });

        let items = GetItems();
        setFirstItem(window.paper.project?.activeLayer?.children[0]);
        if (items?.[0]?.children) {
            SetChildrenGrey(items?.[0], ChangePost);
        }
        let text_items = GetItems({ class: window.paper.TextItem });
        text_items.forEach(function (item) {
            if (!item.is_post) {
                item.sendToBack();
            }
        });

        const post_group = new window.paper.Group();
        post_group.is_temp_group = true;
        post_group.is_post = true;
        post_group.post_adjustment_ref = post_adjustment_ref;
        post_group.nameQQ = pop_item.nameQQ;
        post_group.areaIndex = pop_item.areaIndex;
        post_group.position = pop_item.position;
        post_group.lengthQQ = pop_item.lengthQQ;
        post_group.ref = pop_item.ref;
        post_group.ref2 = pop_item.ref2;
        post_group.ref3 = pop_item.ref3;
        post_group.ref4 = pop_item.ref4;
        post_group.ref5 = pop_item.ref5;
        post_group.beam_p1 = pop_item.beam_p1;
        post_group.beam_p2 = pop_item.beam_p2;
        post_group.post_data = pop_item.post_data;
        post_group.left_post = pop_item.left_post;
        post_group.right_post = pop_item.right_post;
        post_group.left_offset_max = pop_item.left_offset_max;
        post_group.right_offset_max = pop_item.right_offset_max;
        post_group.splice_group = pop_item?.splice_group;
        post_group.post_ref = pop_item?.post_ref;
        post_group.is_splice_post = pop_item?.is_splice_post;

        // setup post_lines to planes
        post_items.forEach(function (post) {
            if (post.nameQQ === pop_item.nameQQ) {
                // this is part of this current post movement
                // post.parent = pop_item;
                post_group.addChild(post);
            } else if (post.is_splice_post || (post.beam_ref && post.beam_ref.includes("Portal"))) {
                post.onMouseDown = function (event) {
                    window.dragging = false;
                    if (post.is_splice_post) {
                        setShowSpliceMessage(true);
                    } else {
                        setShowPortalPostMessage(true);
                    }
                };
            } else {
                // this is part of another post, allow it to switch posts
                post.onMouseDown = function (event) {
                    window.dragging = false;
                    ChangePost(post);
                };
            }
        });

        if (!group.beam_p1) {
            window.last_pop_item = null;
            return;
        }

        const start = window.origin_convert_reverse(getPointForRef(group.beam_p1));
        const end = window.origin_convert_reverse(getPointForRef(group.beam_p2));
        const line = new window.paper.Path.Line({
            temp: true,
            from: [start.x, start.y],
            to: [end.x, end.y],
            strokeColor: "#332197",
            strokeWidth: 50,
        });

        let start_range = getPointForRef(group.left_offset_max);
        start_range = window.origin_convert_reverse(start_range);
        let end_range = getPointForRef(group.right_offset_max);
        end_range = window.origin_convert_reverse(end_range);

        const beam_start_pnt = new window.paper.Point(start.x, start.y);
        const beam_end_pnt = new window.paper.Point(end.x, end.y);

        UpdateBeamStartAndEndMarks(group);

        if (
            window.paper.project.activeLayer.start_mark.post_adjustment_ref === post_group.post_adjustment_ref &&
            window.paper.project.activeLayer.start_mark.nameQQ === post_group.nameQQ
        ) {
            post_group.addChild(window.paper.project.activeLayer.start_mark);
        }

        if (
            window.paper.project.activeLayer.end_mark.post_adjustment_ref === post_group.post_adjustment_ref &&
            window.paper.project.activeLayer.end_mark.nameQQ === post_group.nameQQ
        ) {
            post_group.addChild(window.paper.project.activeLayer.end_mark);
        }

        let start_range_pnt = new window.paper.Point(start_range.x, start_range.y);
        let end_range_pnt = new window.paper.Point(end_range.x, end_range.y);

        if (
            !post_group.post_adjustment_ref.includes("left_post") &&
            !post_group.post_adjustment_ref.includes("right_post")
        ) {
            start_range_pnt = offsetPointAlongLine(beam_start_pnt, beam_start_pnt, beam_end_pnt, 250);
            end_range_pnt = offsetPointAlongLine(beam_end_pnt, beam_start_pnt, beam_end_pnt, -250);
        } else if (post_group.post_adjustment_ref.includes("left_post")) {
            end_range_pnt = offsetPointAlongLine(beam_start_pnt, beam_start_pnt, beam_end_pnt, 1500);
        } else if (post_group.post_adjustment_ref.includes("right_post")) {
            start_range_pnt = offsetPointAlongLine(beam_end_pnt, beam_start_pnt, beam_end_pnt, -1500);
        }

        post_items.forEach(function (item) {
            item.bringToFront();
            //also check if the point in the item is within the beam line and range line, and adjust the range lines accordingly
            const dist_to_line = distancePointToLine(item.position, start_range_pnt, end_range_pnt);
            if (dist_to_line < 100 && post_group.nameQQ !== item.nameQQ && post_group.beam_p1 == item.beam_p1) {
                //if closer to the start
                if (distanceBetween(beam_start_pnt, group.position) > distanceBetween(beam_start_pnt, item.position)) {
                    //is is on the start side
                    if (
                        distanceBetween(start_range_pnt, group.position) >
                        distanceBetween(item.position, group.position)
                    ) {
                        start_range_pnt = projectPointToLine(item.position, beam_start_pnt, beam_end_pnt, true);
                        start_range_pnt = offsetPointAlongLine(start_range_pnt, beam_start_pnt, beam_end_pnt, 200);
                    }
                } else {
                    // it si on the end side
                    if (
                        distanceBetween(end_range_pnt, group.position) > distanceBetween(item.position, group.position)
                    ) {
                        end_range_pnt = projectPointToLine(item.position, start_range_pnt, end_range_pnt, true);
                        end_range_pnt = offsetPointAlongLine(end_range_pnt, beam_start_pnt, beam_end_pnt, -200);
                    }
                }
            }
        });

        const range_line = new window.paper.Path.Line({
            temp: true,
            from: start_range_pnt,
            to: end_range_pnt,
            strokeColor: "red",
            strokeWidth: 25,
        });

        const offset_dist = distancePointToLine(group.position, start_range_pnt, end_range_pnt, false);
        group = post_group;
        group.pivot = pop_item.bounds.center;
        // const offset_dist = 0;

        group.initial_position = group.position;
        window.last_pop_item = group;
        window.last_pop_item.beam_start_pnt = beam_start_pnt;
        window.last_pop_item.beam_end_pnt = beam_end_pnt;
        window.last_pop_item.start_range_pnt = start_range_pnt;
        window.last_pop_item.end_range_pnt = end_range_pnt;
        window.last_pop_item.offset_dist = offset_dist;

        group.bringToFront();

        try {
            group.onMouseDrag = null;
        } catch (e) {}

        group.onMouseDrag = function (event) {
            window.dragging = false;
            if (window.last_pop_item == this) {
                updateDimensions(event.point);
            }
        };
        updateDimensions(group.initial_position);
    }

    function UpdateBeamStartAndEndMarks(post_group) {
        //remove highlight circle for start and end posts

        if (window.paper.project.activeLayer.start_mark != null) {
            window.paper.project.activeLayer.start_mark.remove();
        }
        window.paper.project.activeLayer.start_mark = null;
        if (window.paper.project.activeLayer.end_mark != null) {
            window.paper.project.activeLayer.end_mark.remove();
        }
        window.paper.project.activeLayer.end_mark = null;

        //add highlight circle for start and end posts
        // if (!post_group.beam_p1 || !post_group.beam_p2) {
        //     return;
        // }

        const start = window.origin_convert_reverse(getPointForRef(post_group.beam_p1));
        const end = window.origin_convert_reverse(getPointForRef(post_group.beam_p2));

        if (post_group.is_post) {
            const line = new window.paper.Path.Line({
                temp: true,
                from: [start.x, start.y],
                to: [end.x, end.y],
                strokeColor: "#332197",
                strokeWidth: 50,
            });
        }

        const beam_start_pnt = new window.paper.Point(start.x, start.y);
        const beam_end_pnt = new window.paper.Point(end.x, end.y);

        let origin_pnt = new window.paper.Point(0, 0);

        let post_items = GetItems({ is_post: true });
        post_items.forEach(function (post) {
            const post_start = post.beam_p1 ? window.origin_convert_reverse(getPointForRef(post.beam_p1)) : origin_pnt;
            const post_end = post.beam_p2 ? window.origin_convert_reverse(getPointForRef(post.beam_p2)) : origin_pnt;
            const post_start_pnt = new window.paper.Point(post_start.x, post_start.y);
            const post_end_pnt = new window.paper.Point(post_end.x, post_end.y);

            if (
                (post.beam_p1 == post_group.beam_p1 ||
                    (distanceBetween(post_start_pnt, beam_start_pnt) < 100 &&
                        distanceBetween(post_end_pnt, beam_end_pnt) < 100)) &&
                distanceBetween(post.position, origin_pnt) > 10 &&
                post.typeQQ === "post"
            ) {
                if (post.left_post && !window.paper.project.activeLayer.start_mark) {
                    window.paper.project.activeLayer.start_mark = new window.paper.Path.Circle({
                        post_adjustment_ref: post.post_adjustment_ref,
                        nameQQ: post.nameQQ,
                        center: post.bounds.center,
                        radius: 150,
                        fillColor: null,
                        strokeColor: "darkgreen",
                        strokeWidth: 30,
                        dashArray: [30, 20],
                    });
                }
                if (post.right_post && !window.paper.project.activeLayer.end_mark) {
                    window.paper.project.activeLayer.end_mark = new window.paper.Path.Circle({
                        post_adjustment_ref: post.post_adjustment_ref,
                        nameQQ: post.nameQQ,
                        center: post.bounds.center,
                        radius: 150,
                        fillColor: null,
                        strokeColor: "darkred",
                        strokeWidth: 30,
                        dashArray: [30, 20],
                    });
                }
            }
        });

        if (!window.paper.project.activeLayer.start_mark) {
            window.paper.project.activeLayer.start_mark = new window.paper.Path.Circle({
                center: beam_start_pnt,
                radius: 150,
                fillColor: null,
                strokeColor: "darkgreen",
                strokeWidth: 30,
                dashArray: [30, 20],
            });
        }
        if (!window.paper.project.activeLayer.end_mark) {
            window.paper.project.activeLayer.end_mark = new window.paper.Path.Circle({
                center: beam_end_pnt,
                radius: 150,
                fillColor: null,
                strokeColor: "darkred",
                strokeWidth: 30,
                dashArray: [30, 20],
            });
        }
    }

    function drawDimensionLine(start, end, second) {
        // Calculate dimension span: from projected to end_pnt
        const dimStart = start;
        const dimEnd = end;
        const dimVec = dimEnd.subtract(dimStart);
        const dimLength = dimVec.length;

        if (dimLength < 10) {
            return; // Too short to draw
        }

        // Find the midpoint for the label
        const midPoint = dimStart.add(dimVec.multiply(0.5));

        // Find the normal vector for terminators
        // Compute dim normal (from dimVec) but force it to the preferred side
        let normal = new window.paper.Point(-dimVec.y, dimVec.x);
        if (normal.length < 1e-6) {
            normal = new window.paper.Point(0, 1);
        } else {
            normal = normal.normalize();
        }

        // Preferred normal from the range/reference line so text always goes to the same "outside" side
        const rangeVec = dimEnd.subtract(dimStart);
        let preferredNormal = new window.paper.Point(-rangeVec.y, rangeVec.x);
        if (preferredNormal.length < 1e-6) {
            preferredNormal = new window.paper.Point(0, 1);
        } else {
            preferredNormal = preferredNormal.normalize();
        }

        // If normals point opposite, flip the dim normal so terminators/text stay on preferred side
        if (normal.dot(preferredNormal) < 0) {
            normal = normal.multiply(-1);
        }

        const terminatorLength = 150; // Length of the terminator lines
        const fontSize = 128;

        // Points for terminators (use 'normal' so they are perpendicular to dimVec)
        const t1a = dimStart.add(normal.multiply(terminatorLength / 2));
        const t1b = dimStart.subtract(normal.multiply(terminatorLength / 2));
        const t2a = dimEnd.add(normal.multiply(terminatorLength / 2));
        const t2b = dimEnd.subtract(normal.multiply(terminatorLength / 2));

        let tempDimensionText = window.tempDimensionText;
        let tempTerminator1 = window.tempTerminator1;
        let tempTerminator2 = window.tempTerminator2;
        let tempDimensionLine = window.tempDimensionLine;

        if (second) {
            tempDimensionText = window.temp2DimensionText;
            tempTerminator1 = window.temp2Terminator1;
            tempTerminator2 = window.temp2Terminator2;
            tempDimensionLine = window.temp2DimensionLine;
        }

        // Remove previous temp items
        if (tempDimensionText) tempDimensionText.remove();
        if (tempTerminator1) tempTerminator1.remove();
        if (tempTerminator2) tempTerminator2.remove();
        if (tempDimensionLine) tempDimensionLine.remove();

        // Draw dimension line (optional, for clarity)
        tempDimensionLine = new window.paper.Path.Line({
            from: dimStart,
            to: dimEnd,
            strokeColor: "#c07026ff",
            strokeWidth: 10,
            dashArray: [6, 4],
        });

        // Draw terminators
        tempTerminator1 = new window.paper.Path.Line({
            from: t1a,
            to: t1b,
            strokeColor: "#c07026ff",
            strokeWidth: 20,
        });
        tempTerminator2 = new window.paper.Path.Line({
            from: t2a,
            to: t2b,
            strokeColor: "#c07026ff",
            strokeWidth: 20,
        });
        // Draw dimension text:
        // place at midpoint, offset outward using preferredNormal and add a baseline fudge so the
        // PointText baseline doesn't overlap the dim line.
        const textOffset = terminatorLength / 2 + fontSize * 0.5; // tweak 1 if needed
        const textPoint = midPoint.add(preferredNormal.multiply(-textOffset));

        tempDimensionText = new window.paper.PointText({
            point: textPoint,
            content: `${dimLength.toFixed(0)} mm`,
            fillColor: "#c07026ff",
            fontSize: fontSize,
            fontFamily: 'Consolas, Monaco, "Courier New", monospace', // <- set Monaco with fallbacks
            justification: "center",
        });

        tempDimensionText.isSecond = second;

        tempDimensionText.onMouseUp = function (event) {
            tempDimensionText.content = "|_____ mm";
            window.paperTextTyping = tempDimensionText;
            startCaretBlink();
        };

        if (second) {
            window.temp2DimensionText = tempDimensionText;
            window.temp2Terminator1 = tempTerminator1;
            window.temp2Terminator2 = tempTerminator2;
            window.temp2DimensionLine = tempDimensionLine;
        } else {
            window.tempDimensionText = tempDimensionText;
            window.tempTerminator1 = tempTerminator1;
            window.tempTerminator2 = tempTerminator2;
            window.tempDimensionLine = tempDimensionLine;
        }
    }

    function UpdatePostAdjustment(distance, update_job = false) {
        //store existing post adjustment
        let pop_item = window?.last_pop_item?.is_post ? window.last_pop_item : props.pop_item;
        let existing_adjustment = postAdjustmentsRef.current;
        let new_adjustment = { ...existing_adjustment };
        if (pop_item != null && pop_item.areaIndex !== undefined) {
            let ref = pop_item?.post_adjustment_ref;
            new_adjustment[pop_item.areaIndex] = new_adjustment[pop_item.areaIndex] || {};
            if (new_adjustment[pop_item.areaIndex][ref]) {
                if (Math.abs(new_adjustment[pop_item.areaIndex][ref] - distance) > 2) {
                    new_adjustment[pop_item.areaIndex][ref] = Number(distance.toFixed(1));
                }
            } else {
                new_adjustment[pop_item.areaIndex][ref] = Number(distance.toFixed(1));
            }
            // setPostAdjustments(new_adjustment);
            setPostAdjustments((prev) => {
                return {
                    ...prev,
                    ...new_adjustment,
                };
            });
        }
        if (update_job && pop_item.areaIndex !== undefined) {
            let new_AreaSpecifications = [...AreaSpecifications];

            for (let index in new_AreaSpecifications) {
                let areaIndex = Number(index);
                let this_area_data = new_AreaSpecifications[areaIndex];
                if (new_adjustment[areaIndex]) {
                    new_AreaSpecifications[areaIndex] = {
                        ...this_area_data,
                        PostPositionAdjustments: {
                            ...this_area_data?.PostPositionAdjustments,
                            ...new_adjustment[areaIndex],
                        },
                    };
                }
            }

            dispatch(updateJobParameter("AreaSpecifications", new_AreaSpecifications));

            // dispatch(
            //     updateAreaSpecification(
            //         pop_item.areaIndex,
            //         "PostPositionAdjustments",
            //         null,
            //         new_adjustment[pop_item.areaIndex]
            //     )
            // );
        }
    }

    React.useEffect(() => {
        if (!loaded && props.open) {
            movePost();
            setLoaded(true);
        }
    }, [props?.open]);

    const movePost = () => {
        window.move_post_waiting_for_points = true;
        window.paper.project.deselectAll();
        setLastSVGLoaded(window.last_svg_load_attempt);

        if (window.svg) {
            window.last_pop_item = props.pop_item;
            FormatSVG(props.pop_item);
        }

        dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, true));
        dispatch(APP.update2DDesigner(APP.SELECTED_POINT, false));
        dispatch(APP.update2DDesigner(APP.SELECT_POINT, "Custom"));

        window.prevTool = window.paper.tool;

        window.tempTool = new window.paper.Tool();
        // prefer KeyUp so modifier keys/up-events are handled predictably
        window.tempTool.onKeyUp = function (event) {
            const k = String(event.key || "").toLowerCase();
            stopCaretBlink();
            // allow single digit (0-9)
            if (/^\d$/.test(k)) {
                if (window.paperTextTyping) {
                    window.paperTextTyping.content = window.paperTextTyping.content.replace("_", k);
                    startCaretBlink();
                }
                return;
            }
            // Backspace -> remove last character (before the underscore)
            if (k === "backspace") {
                if (window.paperTextTyping) {
                    const content = window.paperTextTyping.content;
                    // remove char before '_' if present
                    const idx = content.indexOf("_");
                    if (idx > 0) {
                        window.paperTextTyping.content =
                            content.slice(0, Math.max(0, idx - 1)) + "__" + content.slice(idx + 1);
                        startCaretBlink();
                    }
                }
                return;
            }
            // Backspace -> remove last character (before the underscore)
            if (k === "enter") {
                if (window.paperTextTyping) {
                    const content = window.paperTextTyping.content;
                    const distance = toNumber(content);
                    const beam_start_pnt = window.last_pop_item.beam_start_pnt;
                    const beam_end_pnt = window.last_pop_item.beam_end_pnt;
                    if (window.paperTextTyping.isSecond) {
                        window.last_pop_item.position = offsetPointAlongLine(
                            beam_end_pnt,
                            beam_start_pnt,
                            beam_end_pnt,
                            -distance
                        );
                    } else {
                        window.last_pop_item.position = offsetPointAlongLine(
                            beam_start_pnt,
                            beam_start_pnt,
                            beam_end_pnt,
                            distance
                        );
                    }
                    updateDimensions(window.last_pop_item.position);
                }
                return;
            }
            // Escape -> cancel typing / clear
            if (k === "escape") {
                window.paperTextTyping = null;
                return;
            }
            // optionally handle Enter, decimal, minus etc. here
        };

        window.tempTool.onMouseUp = function (e) {
            if (e?.event?.button === 2) {
                dispatch(APP.update2DDesigner(APP.SELECTED_POINT, false));
                dispatch(APP.update2DDesigner(APP.SELECT_POINT, false));
            }
        };

        window.tempTool.activate();
    };

    const onClose = () => {
        window.move_post_waiting_for_points = false;
        setLoaded(false);
        stopCaretBlink();

        if (window.tempDimensionText) window.tempDimensionText.remove();
        if (window.tempTerminator1) window.tempTerminator1.remove();
        if (window.tempTerminator2) window.tempTerminator2.remove();
        if (window.tempDimensionLine) window.tempDimensionLine.remove();
        if (window.temp2DimensionText) window.temp2DimensionText.remove();
        if (window.temp2Terminator1) window.temp2Terminator1.remove();
        if (window.temp2Terminator2) window.temp2Terminator2.remove();
        if (window.temp2DimensionLine) window.temp2DimensionLine.remove();

        window.tempDimensionText = null;
        window.tempTerminator1 = null;
        window.tempTerminator2 = null;
        window.tempDimensionLine = null;
        window.temp2DimensionText = null;
        window.temp2Terminator1 = null;
        window.temp2Terminator2 = null;
        window.temp2DimensionLine = null;

        if (window.last_pop_item && window.last_pop_item.onMouseDrag) {
            try {
                window.last_pop_item.onMouseDrag = null;
            } catch (e) {}
        }

        // window.prevTool.deac();
        // if (window.tempTool) {
        //     window.tempTool.remove();
        // }
        // window.tempTool = null;
        if (window.prevTool) {
            window.prevTool.activate();
        }
        dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, false));

        window.last_pop_item = null;

        if (JSON.stringify(postAdjustmentsOriginal) === JSON.stringify(postAdjustmentsRef.current)) {
            dispatch(updateLayout2D());
        }

        if (props.onClose) {
            props.onClose();
            return;
        }
    };

    return (
        <div
            style={{
                maxWidth: "450px",
                textAlign: "left",
                top: "100px",
                padding: "10px",
                background: "#d7751bab",
                position: "absolute",
                right: "12px",
                zIndex: "5",
                color: "white",
            }}
        >
            <>
                Move post to position or click on dimension text to edit. Right click to confirm location. <br />
                *press 'ESC' to cancel.
            </>

            {window.last_pop_item && (
                <div style={{ background: "#ffffffee" }}>
                    <SpecModifyBeamPostsMenuItem
                        show_full={true}
                        UpdateOriginalPostAdjustment={UpdateOriginalPostAdjustment}
                        togglePop={(toggle, update_post = true) => {
                            let distance = distanceBetween(
                                window.last_pop_item.position,
                                window.last_pop_item.beam_start_pnt
                            );
                            if (update_post) {
                                UpdatePostAdjustment(distance, true);
                            }
                        }}
                        item={
                            window?.last_pop_item?.is_post || window?.last_pop_item?.is_beam
                                ? window.last_pop_item?.post_data
                                    ? window.last_pop_item?.post_data
                                    : window.last_pop_item
                                : props.pop_item?.post_data
                                ? props.pop_item?.post_data
                                : props.pop_item
                        }
                    />
                </div>
            )}

            {(showSpliceMessage || showPortalPostMessage) && (
                <Dialog
                    onClose={() => {
                        setShowSpliceMessage(false);
                        setShowPortalPostMessage(false);
                    }}
                    aria-labelledby="customized-dialog-title"
                    open={showSpliceMessage || showPortalPostMessage}
                    style={{ zIndex: "10000 !important" }}
                >
                    <DialogTitle
                        id="customized-dialog-title"
                        onClose={() => {
                            setShowSpliceMessage(false);
                            setShowPortalPostMessage(false);
                        }}
                    >
                        {showSpliceMessage ? "Splice Post Cannot be Moved" : "Portal Post Cannot be Moved"}
                    </DialogTitle>
                    <DialogContent>
                        {showSpliceMessage
                            ? "This post is added to support a splice. Exit this tool and move the splice to move this post."
                            : "This post is part of a portal frame and cannot be moved."}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={() => {
                                setShowSpliceMessage(false);
                                setShowPortalPostMessage(false);
                            }}
                            color="primary"
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>
    );
}
